/**
 * Complete-email check: a non-empty local part, an `@`, and a dotted domain
 * with a 2+ character TLD, no whitespace. Shared by the recipient picker, the
 * invite input and the contact override field so they all agree on what counts
 * as a valid address.
 */
export const isValidEmail = (value: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
